import React from 'react'
import { IconButton, useTheme } from '@mui/material'
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt'
const ThumbsDownButton = ({ id, isRejecting, onReject, size = 24 }) => {
  const theme = useTheme()
  return (
    <>
      <IconButton id={id} size="small" disabled={isRejecting} onClick={onReject} name="isApproved">
        <ThumbDownOffAltIcon
          sx={{
            height: size ?? 24,
            width: size ?? 24,
            color: theme.palette.icon.decline,
          }}
        />
      </IconButton>
    </>
  )
}

export default ThumbsDownButton
